(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  /* Scroll-reveal-on-scroll */
  function initReveal() {
    var els = document.querySelectorAll('[data-dz-reveal]');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('dz-revealed'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('dz-revealed');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -60px 0px' });
    els.forEach(function (el) {
      var delay = el.getAttribute('data-dz-delay');
      if (delay) el.style.setProperty('--dz-delay', delay + 'ms');
      io.observe(el);
    });
  }

  /* Header: sticky shadow + mobile hamburger */
  function initHeader() {
    var header = document.querySelector('[data-dz-header]');
    if (!header) return;
    var burger = header.querySelector('[data-dz-burger]');
    var mobile = header.querySelector('[data-dz-mobile-menu]');
    if (burger && mobile) {
      burger.addEventListener('click', function () {
        var open = mobile.classList.toggle('is-open');
        burger.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
      mobile.querySelectorAll('a').forEach(function (link) {
        link.addEventListener('click', function () {
          mobile.classList.remove('is-open');
          burger.setAttribute('aria-expanded', 'false');
        });
      });
    }
  }

  /* Generic tabs: [data-dz-tabs] wraps buttons [data-dz-tab-btn="key"] and panels [data-dz-tab-panel="key"] */
  function initTabs() {
    document.querySelectorAll('[data-dz-tabs]').forEach(function (root) {
      var buttons = root.querySelectorAll('[data-dz-tab-btn]');
      var scope = root.getAttribute('data-dz-tabs');
      var panels = document.querySelectorAll('[data-dz-tab-panel][data-dz-tabs-scope="' + scope + '"]');

      function activate(key, scrollTo) {
        buttons.forEach(function (btn) {
          btn.classList.toggle('is-active', btn.getAttribute('data-dz-tab-btn') === key);
        });
        panels.forEach(function (panel) {
          panel.classList.toggle('is-active', panel.getAttribute('data-dz-tab-panel') === key);
        });
        if (scrollTo) {
          var anchor = document.getElementById(key) || root;
          window.scrollTo({ top: anchor.getBoundingClientRect().top + window.scrollY - 20, behavior: 'smooth' });
        }
      }

      buttons.forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          activate(btn.getAttribute('data-dz-tab-btn'), false);
        });
      });

      root.__dzActivateTab = activate;
    });

    /* Cards that jump straight to a tab + scroll (used by "What Can You Build") */
    document.querySelectorAll('[data-dz-goto-tab]').forEach(function (card) {
      card.addEventListener('click', function (e) {
        var key = card.getAttribute('data-dz-goto-tab');
        var scope = card.getAttribute('data-dz-goto-tab-scope');
        var tabsRoot = scope ? document.querySelector('[data-dz-tabs="' + scope + '"]') : null;
        if (tabsRoot && tabsRoot.__dzActivateTab) {
          e.preventDefault();
          tabsRoot.__dzActivateTab(key, true);
        }
      });
    });
  }

  /* Accordion (FAQ) */
  function initAccordion() {
    document.querySelectorAll('[data-dz-accordion-item]').forEach(function (item) {
      var btn = item.querySelector('[data-dz-accordion-btn]');
      var sign = item.querySelector('[data-dz-accordion-sign]');
      if (!btn) return;
      btn.addEventListener('click', function () {
        var open = item.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (sign) sign.textContent = open ? '−' : '+';
      });
    });
  }

  /* Product gallery thumbnail swap */
  function initGallery() {
    document.querySelectorAll('[data-dz-gallery]').forEach(function (gallery) {
      var mainImgs = gallery.querySelectorAll('[data-dz-gallery-image]');
      var thumbs = gallery.querySelectorAll('[data-dz-gallery-thumb]');
      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          var key = thumb.getAttribute('data-dz-gallery-thumb');
          mainImgs.forEach(function (img) {
            img.classList.toggle('is-active', img.getAttribute('data-dz-gallery-image') === key);
          });
          thumbs.forEach(function (t) {
            t.classList.toggle('is-active', t === thumb);
          });
        });
      });
    });
  }

  /* Installation guide sticky side-nav scroll-spy */
  function initScrollSpy() {
    var links = document.querySelectorAll('[data-dz-navspy-link]');
    var sections = document.querySelectorAll('[data-dz-navspy-section]');
    if (!links.length || !sections.length) return;

    function onScroll() {
      var pos = window.scrollY + 140;
      var current = null;
      sections.forEach(function (section) {
        if (section.getBoundingClientRect().top + window.scrollY <= pos) {
          current = section.getAttribute('data-dz-navspy-section');
        }
      });
      links.forEach(function (link) {
        link.classList.toggle('is-current', link.getAttribute('data-dz-navspy-link') === current);
      });
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* Block calculator: length x width x lumber span -> estimated block count */
  function initCalculator() {
    document.querySelectorAll('[data-dz-calculator]').forEach(function (root) {
      var lengthInput = root.querySelector('[data-dz-calc-length]');
      var widthInput = root.querySelector('[data-dz-calc-width]');
      var spanSelect = root.querySelector('[data-dz-calc-span]');
      var button = root.querySelector('[data-dz-calc-submit]');
      var result = root.querySelector('[data-dz-calc-result]');
      if (!button || !result) return;

      button.addEventListener('click', function () {
        var lengthFt = parseFloat(lengthInput.value);
        var widthFt = parseFloat(widthInput.value);
        var maxSpan = parseFloat(spanSelect.value);

        if (!isFinite(lengthFt) || !isFinite(widthFt) || lengthFt <= 0 || widthFt <= 0) {
          result.textContent = result.getAttribute('data-dz-calc-error-text') || 'Please enter both deck length and width.';
          return;
        }

        var lengthIn = lengthFt * 12;
        var widthIn = widthFt * 12;
        var blocksPerLine = Math.max(2, Math.ceil(lengthIn / maxSpan) + 1);
        var joistLines = Math.max(2, Math.ceil(widthIn / 16) + 1);
        var totalBlocks = blocksPerLine * joistLines;
        var area = lengthFt * widthFt;

        var areaLabel = result.getAttribute('data-dz-calc-area-label') || 'Estimated Deck Area:';
        var blocksLabel = result.getAttribute('data-dz-calc-blocks-label') || 'Estimated DeckEzy Blocks:';

        result.innerHTML =
          '<strong>' + areaLabel + '</strong> ' + area + ' sq ft<br><br>' +
          '<strong>' + blocksLabel + '</strong> ' + totalBlocks;
      });
    });
  }

  /* Calculator panel: combined hero + calculator, with a stats strip (blocks, area, spacing, rows) */
  function initCalcPanel() {
    document.querySelectorAll('[data-dz-calc-panel]').forEach(function (root) {
      var lengthInput = root.querySelector('[data-dz-calc-length]');
      var widthInput = root.querySelector('[data-dz-calc-width]');
      var spanSelect = root.querySelector('[data-dz-calc-span]');
      var button = root.querySelector('[data-dz-calc-submit]');
      var scope = root.closest('[data-dz-calc-scope]') || root.parentElement;
      var errorEl = scope.querySelector('[data-dz-calc-error]');
      var totalEl = scope.querySelector('[data-dz-calc-total]');
      var areaEl = scope.querySelector('[data-dz-calc-area]');
      var spacingEl = scope.querySelector('[data-dz-calc-spacing]');
      var rowsEl = scope.querySelector('[data-dz-calc-rows]');
      if (!button) return;

      button.addEventListener('click', function () {
        var lengthFt = parseFloat(lengthInput.value);
        var widthFt = parseFloat(widthInput.value);
        var maxSpan = parseFloat(spanSelect.value);

        if (!isFinite(lengthFt) || !isFinite(widthFt) || lengthFt <= 0 || widthFt <= 0) {
          if (errorEl) errorEl.hidden = false;
          return;
        }
        if (errorEl) errorEl.hidden = true;

        var lengthIn = lengthFt * 12;
        var widthIn = widthFt * 12;
        var blocksPerLine = Math.max(2, Math.ceil(lengthIn / maxSpan) + 1);
        var joistLines = Math.max(2, Math.ceil(widthIn / 16) + 1);
        var totalBlocks = blocksPerLine * joistLines;
        var area = lengthFt * widthFt;

        if (totalEl) totalEl.textContent = totalBlocks;
        if (areaEl) areaEl.textContent = area.toLocaleString();
        if (spacingEl) spacingEl.textContent = maxSpan + '"';
        if (rowsEl) rowsEl.textContent = joistLines;
      });
    });
  }

  ready(function () {
    initReveal();
    initHeader();
    initTabs();
    initAccordion();
    initGallery();
    initScrollSpy();
    initCalculator();
    initCalcPanel();
  });
})();
